'use client'

import { Box, Typography, Grid } from '@material-ui/core'
import { SeatStatus } from 'config/constants'
import { getStatusColor, getStatusName } from '../lib/utils'

export default function StatusLegend({
  selectedStatus,
  setSelectedStatus,
  statusCounts = {}
}) {
  const statuses = [
    SeatStatus.Empty,
    SeatStatus.Available,
    SeatStatus.Disabled,
    SeatStatus.Blocked
  ]

  const handleSelect = (status) => {
    if (setSelectedStatus) setSelectedStatus(status)
  }

  return (
    <Box>
      <Typography variant='subtitle2' gutterBottom>
        Estado de Asientos
      </Typography>
      <Grid container spacing={1}>
        {statuses.map((status) => (
          <Grid item xs={6} key={status}>
            <Box
              sx={{
                border:
                  selectedStatus === status
                    ? '1px solid #1976d2'
                    : '1px solid lightgray',
                borderRadius: '4px',
                padding: '4px 4px',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                cursor: 'pointer',
                transition: 'border 0.1s'
              }}
              onClick={() => handleSelect(status)}>
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  backgroundColor: getStatusColor(status),
                  border: '1px solid #ccc',
                  borderRadius: '2px',
                  marginRight: 1
                }}
              />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%'
                }}>
                <Typography
                  variant='body2'
                  sx={{
                    fontWeight: selectedStatus === status ? 'bold' : 'normal',
                    color: selectedStatus === status ? '#1976d2' : 'inherit'
                  }}>
                  {getStatusName(status)}
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    marginLeft: 1,
                    color: '#888'
                  }}>
                  {statusCounts[status] ?? 0}
                </Typography>
              </div>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}
